<template>
  <VueDraggable
    :model-value="modelValue"
    tag="div"
    class="flex flex-col gap-2"
    handle=".cursor-grab"
    :animation="150"
    ghost-class="category-ghost"
    :group="CATEGORY_DRAG_GROUP"
    :disabled="disabled"
    :scroll="true"
    :scroll-sensitivity="80"
    :scroll-speed="20"
    :bubble-scroll="true"
    :force-auto-scroll-fallback="true"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <div
      v-for="category in modelValue"
      :key="category.id"
      class="category-row flex items-center gap-2 p-2 rounded border-theme"
    >
      <v-icon
        icon="mdi-drag-vertical"
        size="small"
        class="cursor-grab text-medium-emphasis"
      ></v-icon>
      <span>{{ category.name }}</span>
      <v-spacer></v-spacer>
      <span class="text-medium-emphasis">{{ category.amountLabel }}</span>
      <v-btn
        icon="mdi-pencil-outline"
        size="small"
        variant="text"
        density="comfortable"
        :disabled="disabled"
        @click="emit('rename', category)"
      ></v-btn>
      <v-btn
        icon="mdi-trash-can-outline"
        size="small"
        variant="text"
        density="comfortable"
        :disabled="disabled"
        @click="emit('delete', category)"
      ></v-btn>
    </div>
  </VueDraggable>
</template>

<script lang="ts" setup>
import { VueDraggable } from "vue-draggable-plus";

interface Category {
  id: string;
  name: string;
  amount: number;
  amountLabel: string;
  groupId: string | undefined;
}

const CATEGORY_DRAG_GROUP = "tracked-categories";

defineProps<{ modelValue: Category[]; disabled: boolean }>();

const emit = defineEmits<{
  delete: [category: Category];
  rename: [category: Category];
  "update:modelValue": [value: Category[]];
}>();
</script>

<style scoped>
.category-row {
  background-color: rgb(var(--v-theme-surface));
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
}
.cursor-grab {
  cursor: grab;
}
.cursor-grab:active {
  cursor: grabbing;
}
</style>

<!-- Sortable may attach the ghost element outside this subtree -->
<style>
.category-ghost {
  opacity: 0.55;
}
</style>
